/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React, { Fragment, useEffect, useState } from 'react'

import { EuiFormRow, EuiFieldText, EuiSpacer } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'
import type { TrafficFilterRule } from '@modules/cloud-api/v1/types'

type Props = {
  rules: TrafficFilterRule[] | undefined
  onChange: (rules: TrafficFilterRule[]) => void
}

const VpceFilterField: React.FunctionComponent<Props> = ({ rules = [], onChange }) => {
  const [resourceName, setResourceName] = useState(rules[0]?.azure_endpoint_name || '')
  const [resourceId, setResourceId] = useState(rules[0]?.azure_endpoint_guid || '')

  useEffect(() => {
    onChange([
      {
        azure_endpoint_name: resourceName,
        azure_endpoint_guid: resourceId,
      },
    ])
  }, [resourceName, resourceId])

  return (
    <Fragment>
      <EuiFormRow
        label={
          <FormattedMessage
            id='azurePrivateLinkResourceNameField.label'
            defaultMessage='Resource name'
          />
        }
      >
        <EuiFieldText
          placeholder='e.g. my-azure-virtual-net'
          value={resourceName}
          onChange={(e) => setResourceName(e.target.value)}
          fullWidth={true}
        />
      </EuiFormRow>
      <EuiSpacer size='m' />
      <EuiFormRow
        label={
          <FormattedMessage
            id='azurePrivateLinkResourceIdField.label'
            defaultMessage='Resource ID'
          />
        }
      >
        <EuiFieldText
          placeholder='e.g. 17d9ae7c-5dbf-4bD1-b171-722ff7ac7c7e'
          value={resourceId}
          onChange={(e) => setResourceId(e.target.value)}
          fullWidth={true}
        />
      </EuiFormRow>
    </Fragment>
  )
}

export default VpceFilterField
